import { Component, OnInit, signal } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { RatingModule } from 'primeng/rating';
import { Table, TableModule } from 'primeng/table';
import { InputIconModule } from 'primeng/inputicon';
import { IconFieldModule } from 'primeng/iconfield';
import { CommonModule } from '@angular/common';
import { MessageService } from 'primeng/api';
import { TagModule } from 'primeng/tag';
import { FormsModule } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { ChartModule } from 'primeng/chart';
import { SelectModule } from 'primeng/select';
import { InputTextModule } from 'primeng/inputtext';
import { TextareaModule } from 'primeng/textarea';
import { InputNumberModule } from 'primeng/inputnumber';
import { RadioButtonModule } from 'primeng/radiobutton';
import { DatePickerModule } from 'primeng/datepicker';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { Toast } from 'primeng/toast';
import { BankrolService } from '../../services/bankrol.service';
import { DropdownModule } from 'primeng/dropdown';
interface PariData {
  id?: number;
  user_id?: string;
  event_date?: Date;
  event_name?: string;
  status?: string;
  cote?: number;
  mise?: number;
  nbr_paris?: number;
}
@Component({
  selector: 'app-bankroll',
  imports: [ButtonModule, Toast, FormsModule, DropdownModule, ChartModule, ConfirmDialogModule, DatePickerModule, RadioButtonModule, InputNumberModule, TextareaModule, InputTextModule, SelectModule, TagModule, DialogModule, TableModule, RatingModule, InputIconModule, IconFieldModule, CommonModule],
  templateUrl: './bankroll.component.html',
  styleUrl: './bankroll.component.scss',
  providers: [MessageService],
})
export class BankrollComponent implements OnInit {
  statuses!: any[];
  lineData: any;
  pariDialog: boolean = false;
  submitted: boolean = false;
  isEditMode: boolean = false;
  cancelDialogParis: boolean = false;
  listOfParis = signal<PariData[]>([]);
  lineOptions: any;
  display: boolean = false;
  pari!: PariData;
  periodOptions = [
    { label: '7 derniers jours', value: '7' },
    { label: '30 derniers jours', value: '30' },
    { label: '3 derniers mois', value: '90' },
    { label: '6 derniers mois', value: '180' },
    { label: '1 an', value: '365' },
    { label: 'Tout', value: 'all' }
  ];
  selectedPeriod = signal<string>('30');


  isMobile = window.innerWidth < 768;


  capitalActuelle: number = 0;
  nombreDeParis: number = 0;
  totalMises: number = 0;
  roi: number = 0;
  constructor(
    private messageService: MessageService,
    private bankrolService: BankrolService
  ) {
  }
  ngOnInit() {
    this.loadParisData()
    this.statuses = [
      { label: 'PERDU', value: 'perdu' },
      { label: 'GAGNE', value: 'gagne' },
    ];
  }

  onPeriodChange(event: { value: string }) {
    this.selectedPeriod.set(event.value);
    this.loadParisData();
  }



  calculateStats(paris: PariData[]) {
    let capital = 0;
    let mises = 0;
    console.log(paris);
    paris.forEach(pari => {
      if (pari.status === 'GAGNE') {
        if (pari.cote && pari.mise) {
          capital += (pari.mise || 0) * ((pari.cote - 1) || 0);
        }
      } else if (pari.status === 'PERDU') {
        capital -= (pari.mise || 0);
      }
      mises += (pari.mise || 0);
    });

    this.capitalActuelle = capital;
    this.nombreDeParis = paris.length;
    this.totalMises = mises;
    this.roi = mises > 0 ? Math.round(((capital) / mises) * 100) : 0;
  }
  openNew() {
    this.pari = {};
    this.submitted = false;
    this.pariDialog = true;
  }
  createParis() {

    const user = JSON.parse(localStorage.getItem('user') || '{}');
    if (!user || !user.user_id) {
      this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Utilisateur non connecté' });
      return;
    }
    if (!this.isEditMode) {
      this.bankrolService.createParis(this.pari, user.user_id).subscribe({
        next: (response) => {
          this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Paris créé avec succès' });
          this.pariDialog = false;
          this.submitted = false;
          this.loadParisData();
        },
        error: (error) => {
          console.error('Erreur lors de la création du pari:', error);
          this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Échec de la création du pari' });
        }
      })
    } else {
      this.bankrolService.updatePari(this.pari.id!, this.pari).subscribe({
        next: (response) => {
          this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Paris mis à jour avec succès' });
          this.pariDialog = false;
          this.submitted = false;
          this.loadParisData();
        },
        error: (error) => {
          console.error('Erreur lors de la mise à jour du pari:', error);
          this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Échec de la mise à jour du pari' });
        }
      })
      this.pariDialog = false;
      this.submitted = false;
      this.isEditMode = false;
      this.loadParisData();

    }

  }
  hideDialog() {
    this.pariDialog = false;
    this.submitted = false;
  }
  loadParisData() {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    if (!user || !user.user_id) {
      this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Utilisateur non connecté' });
      return;
    }
    this.bankrolService.getUserParis(user.user_id, this.selectedPeriod()).subscribe({
      next: (data) => {
        this.listOfParis.set(data);
        this.calculateStats(data);
        this.updateChartWithROI(data);
      },
      error: (error) => {
        console.error('Erreur lors du chargement des paris:', error);
        this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Échec du chargement des paris' });
      }
    });
  }
  getSeverity(status: string) {
    switch (status) {
      case 'GAGNE':
        return 'success';
      case 'PERDU':
        return 'warn';
      default:
        return 'info';
    }
  }

  onGlobalFilter(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }
  deleteParis(pari: PariData) {
    this.cancelDialogParis = true;
    this.pari = { ...pari };

  }
  confirmCancel() {
    if (!this.pari.id) {
      this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Paris non trouvé' });
      return;
    }
    this.bankrolService.deletePari(this.pari.id.toString()).subscribe({
      next: (response) => {
        this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Paris supprimé avec succès' });
        this.cancelDialogParis = false;
        this.loadParisData();
      },
      error: (error) => {
        console.error('Erreur lors de la suppression du pari:', error);
        this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Échec de la suppression du pari' });
      }
    });

  }

  editParis(pari: PariData) {
    this.isEditMode = true;
    this.pariDialog = true
    this.pari = { ...pari, event_date: pari.event_date ? new Date(pari.event_date) : undefined };
    this.submitted = false;
  }

  showDialog() {
    this.display = true;
  }



  updateChartWithROI(paris: PariData[]) {
    const roiParDate: Record<string, { mise: number; gain: number }> = {};

    paris.forEach(pari => {
      const date = new Date(pari.event_date!).toLocaleDateString('fr-FR'); // format "14/07/2025"
      if (!roiParDate[date]) {
        roiParDate[date] = { mise: 0, gain: 0 };
      }

      const mise = pari.mise || 0;
      const cote = pari.cote || 0;
      roiParDate[date].mise += mise;

      if (pari.status === 'GAGNE') {
        roiParDate[date].gain += mise * cote;
      } else if (pari.status === 'PERDU') {
        roiParDate[date].gain -= mise;
      }
    });

    const sortedDates = Object.keys(roiParDate).sort((a, b) => {
      const d1 = new Date(a.split('/').reverse().join('-'));
      const d2 = new Date(b.split('/').reverse().join('-'));
      return d1.getTime() - d2.getTime();
    });

    const labels: string[] = [];
    const roiData: number[] = [];

    sortedDates.forEach(date => {
      const { mise, gain } = roiParDate[date];
      const roi = mise > 0 ? ((gain - mise) / mise) * 100 : 0;
      labels.push(date);
      roiData.push(+roi.toFixed(2));
    });

    this.lineData = {
      labels,
      datasets: [
        {
          label: 'ROI (%)',
          data: roiData,
          fill: false,
          borderColor: '#42A5F5',
          backgroundColor: '#42A5F5',
          tension: 0.4,
          pointRadius: 6,
          pointHoverRadius: 8,
          pointBackgroundColor: '#42A5F5',
          pointBorderColor: '#ffffff',
          pointBorderWidth: 2,
          pointHoverBackgroundColor: '#42A5F5',
          pointHoverBorderColor: '#ffffff'
        }
      ]
    };

    this.lineOptions = {
      responsive: true,
      maintainAspectRatio: false,

      plugins: {
        legend: {
          position: 'top',
          labels: {
            usePointStyle: true,
            color: '#495057'
          }
        },
        title: {
          display: true,
          text: 'Évolution de votre ROI sur vos paris',
          font: {
            size: 16,
            weight: 'bold'
          },
          color: '#495057'
        },
        tooltip: {
          mode: 'index',
          intersect: false,
          callbacks: {
            label: function (context: any) {
              return context.dataset.label + ': ' + context.parsed.y.toFixed(2) + '%';
            }
          }
        }
      },
      scales: {
        x: {
          display: true,
          title: {
            display: true,
            text: 'Date',
            color: '#6c757d'
          },
          grid: {
            color: '#e9ecef'
          },
          ticks: {
            color: '#6c757d'
          }
        },
        y: {
          display: true,
          title: {
            display: true,
            text: 'ROI (%)',
            color: '#6c757d'
          },
          grid: {
            color: '#e9ecef'
          },
          ticks: {
            color: '#6c757d',
            callback: function (value: any) {
              return value + '%';
            }
          },
          beginAtZero: true
        }
      },
      interaction: {
        mode: 'nearest' as const,
        axis: 'x' as const,
        intersect: false
      }
    };
  }


}